import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { merge, Subject, timer } from 'rxjs';
import { switchMap, takeUntil, filter, debounceTime } from 'rxjs/operators';
import { AssignTaskComponent } from 'app/layout/common/assign-task/assign-task.component';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { SignalRService } from './signalr.service';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';

@Injectable({ providedIn: 'root' })
export class PendingTaskInwardService implements OnDestroy {


    private destroy$ = new Subject<void>();
    private popupOpen = false;

    constructor(
        private _matDialog: MatDialog,
        private _inwardService: InwardsService,
        private signalRService: SignalRService
    ) { }

    start(): void {
        // Start SignalR
        this.signalRService.startConnection();

        // 🔁 Triggers:
        // 1️⃣ Every 1 hour
        // 2️⃣ Whenever SignalR event arrives
        merge(
            timer(0, 60 * 60 * 1000),      // polling
            this.signalRService.inwardUpdates$ // realtime
        )
            .pipe(
                debounceTime(500), // prevent duplicate calls
                takeUntil(this.destroy$),
                switchMap(() => this._inwardService.getPendingInwards()),
                filter(inwards => inwards.length > 0)
            )
            .subscribe(inwards => this.openPopup(inwards));
    }

    private openPopup(inwards: Inward[]): void {
        if (!this.popupOpen) {
            this.popupOpen = true;

            this._matDialog.open(AssignTaskComponent, {
                maxWidth:'650px',
                maxHeight: '400px',
                disableClose: true,
                data: inwards
            }).afterClosed().subscribe(() => {
                this.popupOpen = false;
            });

        }
    }
   
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
